import qs from 'qs';

export const generateSpaceQuery = (slug?: string): string => {
    const filters = slug
        ? {
            slug: {
                $eq: slug,
            },
        } : undefined;

    const populate = {
        image: {
            fields: ['*'],
        },
        productCategories: {
            populate: ['image', 'lineImage'],
        },
        productSelections: {
            fields: ['*'],
        },
        seo: { populate: '*' },
    };

    return qs.stringify({
        filters,
        populate,
    }, {
        encodeValuesOnly: true,
    });
};
